function initVerifiedReviewsSliders() {
  var sections = document.querySelectorAll('.vr-section');

  sections.forEach(function (section) {
    if (section.getAttribute('data-vr-initialized') === 'true') return;
    section.setAttribute('data-vr-initialized', 'true');

    var slider = section.querySelector('[data-vr-slider]');
    var prevBtn = section.querySelector('[data-vr-prev]');
    var nextBtn = section.querySelector('[data-vr-next]');

    if (!slider) return;

    function scrollByPage(direction) {
      var amount = slider.clientWidth * 0.9 * direction;
      slider.scrollBy({ left: amount, behavior: 'smooth' });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        scrollByPage(1);
      });
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        scrollByPage(-1);
      });
    }

    function updateArrowVisibility() {
      if (!prevBtn || !nextBtn) return;
      var maxScroll = slider.scrollWidth - slider.clientWidth - 2;

      if (maxScroll <= 0) {
        prevBtn.style.display = 'none';
        nextBtn.style.display = 'none';
        return;
      }

      prevBtn.style.display = 'flex';
      nextBtn.style.display = 'flex';
      prevBtn.style.opacity = slider.scrollLeft <= 0 ? '0.35' : '1';
      prevBtn.style.pointerEvents = slider.scrollLeft <= 0 ? 'none' : 'auto';
      nextBtn.style.opacity = slider.scrollLeft >= maxScroll ? '0.35' : '1';
      nextBtn.style.pointerEvents = slider.scrollLeft >= maxScroll ? 'none' : 'auto';
    }

    slider.addEventListener('scroll', updateArrowVisibility);
    window.addEventListener('resize', updateArrowVisibility);

    updateArrowVisibility();
    window.requestAnimationFrame(updateArrowVisibility);
    setTimeout(updateArrowVisibility, 300);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initVerifiedReviewsSliders);
} else {
  initVerifiedReviewsSliders();
}

document.addEventListener('shopify:section:load', initVerifiedReviewsSliders);